/**
 * Rückweg-Link der Anmeldeflächen.
 *
 * <p>Zwei dieser Links trugen bis Sprint 55 die Klasse `btn-ghost` — die es in `globals.css`
 * nicht gibt und nie gab. Sie rendern deshalb als nackter Fließtext mitten in einer Karte, ohne
 * Trefferfläche und ohne erkennbaren Fokus. Hier steht die Ausprägung einmal, damit die vier
 * Seiten denselben Rückweg zeigen.</p>
 */
export const authBackLinkClass =
  'text-ink-soft hover:text-ink focus-visible:ring-sage inline-flex min-h-11 items-center justify-center rounded-md px-3 text-sm underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2';
